export default theme => ({
  root: {
    position: 'relative',
    transition: {
      property: 'opacity',
      duration: theme.transitions.duration.short,
      timingFunction: theme.transitions.easing.easeIn,
    }
  },
  rootDisabled: {
    opacity: 0.5
  },
  disabledOverlay: {
    position: 'absolute',
    content: '""',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 1,
    '&:focus': {
      outline: 'none'
    }
  },
  children: {
    [theme.breakpoints.up('md')]: {
      paddingBottom: theme.spacing.unit * 3
    },
    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing.unit
    }
  },
  title: {
    extend: 'children',
    display: 'flex',
    alignItems: 'center'
  },
  titleIndex: {
    marginRight: theme.spacing.unit
  },
  titleLabel: {
    flex: 1
  },
  button: {
    transition: {
      property: 'opacity',
      duration: theme.transitions.duration.short,
      timingFunction: theme.transitions.easing.easeIn,
    }
  },
  buttonHidden: {
    opacity: 0
  },
  skipButton: {
    marginRight: theme.spacing.unit * 2
  }
});



// WEBPACK FOOTER //
// ./src/components/ScrollForm/Section/styles.js